import styles from "./Textarea.module.css";

interface TextareaProps {
  readonly name: string;
  readonly id?: string;
  readonly placeholder?: string;
  readonly value?: string;
  readonly onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  readonly required?: boolean;
  readonly disabled?: boolean;
  readonly error?: boolean;
  readonly rows?: number;
  readonly className?: string;
  readonly "aria-label"?: string;
  readonly "aria-describedby"?: string;
}

export function Textarea({
  name,
  id,
  placeholder,
  value,
  onChange,
  required,
  disabled,
  error,
  rows = 3,
  className,
  "aria-label": ariaLabel,
  "aria-describedby": ariaDescribedBy,
}: TextareaProps) {
  return (
    <textarea
      name={name}
      id={id}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      rows={rows}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-invalid={error || undefined}
      className={`${styles.textarea} ${error ? styles.error : ""} ${className ?? ""}`}
    />
  );
}
